'use strict'
import Services from '../../services/Services';

export async function getPropertyList(data) {
    let message;
    const res = await Services.api(`properties/list`, data, 'post');

    if (res.status === 200) {
        message = res.data;
    } else {
        message = res.message;
    }

    return {
        "status": res.status,
        "message": message
    };
}